import React, { useEffect } from 'react';
import { PolicyName } from './styled';
import EarlierOrder from './EarlierOrder';
import { sortBy } from 'lodash';
import { useSelector } from 'react-redux';
import { policiesSelector } from '@store/policies/precisionPolicy/selectors';

const PopupView = ({ order }) => {
  const unOrderedPolicies: any = useSelector(policiesSelector);
  const policies = sortBy(unOrderedPolicies, (p) => order.indexOf(p.id));
  const sortedPolices = sortBy(unOrderedPolicies, (p) => p.index);
  const originalOrder = sortedPolices.map((p) => p.id);

  return (
    <div>
      {policies.map((policy, idx) => (
        <div style={{ display: 'flex' }} key={idx}>
          <EarlierOrder policy={policy} idx={idx + 1} order={order} originalOrder={originalOrder} />
          <PolicyName>
            <span>{`${policy.versions[0].name}`}</span>
          </PolicyName>
        </div>
      ))}
    </div>
  );
};

export default PopupView;
